import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss']
})
export class BannerComponent implements OnInit {
  @Input() img1 = '/assets/img/banner/1.png';
  constructor() { }

  ngOnInit(): void {
  }

}
